import { IndexStatusResponse } from '@features/indexing/hooks/types'
import { indexStatuses } from '@features/indexing/hooks/useGetIndexStatus'
import Check from '@mui/icons-material/Check'
import PriorityHigh from '@mui/icons-material/PriorityHigh'
import Clear from '@mui/icons-material/Clear'
import { CircularProgressProps } from '@mui/material/CircularProgress'

export const getStatusValue = (data?: IndexStatusResponse) => {
  const numberOfProcessedFiles = data?.number_of_processed_files || 0
  const numberOfFailedFiles = data?.number_of_failed_files || 0
  const numberOfFilesSubmitted = data?.number_of_files_submitted || 0

  return (
    ((numberOfProcessedFiles + numberOfFailedFiles) / (numberOfFilesSubmitted === 0 ? 1 : numberOfFilesSubmitted)) * 100
  )
}

export const getColorByStatus = (status: string | undefined): CircularProgressProps['color'] => {
  switch (status) {
    case indexStatuses.CREATED:
    case indexStatuses.INITIALIZING:
    case indexStatuses.IN_PROGRESS:
      return 'primary'
    case indexStatuses.READY:
      return 'success'
    case indexStatuses.FAILED:
    case null:
    case undefined:
      return 'error'
    case indexStatuses.STOPPED:
      return 'warning'
    default:
      return 'secondary'
  }
}

export const getIconByStatus = (status?: string, value?: number) => {
  switch (status) {
    case indexStatuses.CREATED:
    case indexStatuses.INITIALIZING:
    case indexStatuses.IN_PROGRESS:
      return `${value}%`
    case indexStatuses.READY:
      return <Check sx={{ fontSize: 'inherit' }} />
    case indexStatuses.FAILED:
    case null:
    case undefined:
      return <PriorityHigh sx={{ fontSize: 'inherit' }} />
    case indexStatuses.STOPPED:
      return <Clear sx={{ fontSize: 'inherit' }} />
    default:
      return null
  }
}
